import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import DetectorController from '../../controller/DetectorController';
import { useNavigate } from 'react-router-dom';
import { APP_TYPE } from '../../utils/DataType';

interface InputStoreProps {
  storeList: HotelSelectType[];
  storeType: number;
  getSignInData: any;
}

type HotelSelectType = {
  name: string;
  store_id: number;
  user_id: number;
};

let oWindow: Window | null = null;

const RenderFilterStore = ({ storeList, storeType, getSignInData }: InputStoreProps) => {
  const [keyword, setKeyword] = useState<string>('');
  const [searchedList, setSearchedList] = useState<HotelSelectType[]>([]);

  const getSearchResult = () => {
    if (storeType === 0) {
      setSearchedList(storeList.filter((item) => item.name.includes(keyword)));
    } else {
      getStoreByName();
    }
  };

  useEffect(() => {
    setKeyword('');
    if (storeType === 0) {
      getSearchResult();
    } else {
      getStoreByName();
    }
  }, [storeList, storeType]);

  const getStoreByName = async () => {
    try {
      const oData = {
        store_name: keyword,
      };

      const response = await DetectorController.getStoreByName(oData);

      if (response && response.data) {
        const formattedStoreList = response.data.data.map((item: any) => ({
          name: item.store_name,
          store_id: item.store_id,
          user_id: item.user_id,
        }));
        setSearchedList(formattedStoreList);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  return (
    <div className="inputArea">
      <div className="inputWrap">
        <input
          value={keyword}
          placeholder="검색어를 입력하세요"
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              getSearchResult();
            }
          }}
        />
        <button onClick={getSearchResult}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_search.svg`} alt="search" />
        </button>
      </div>
      <div className="resultBox">
        {searchedList.length > 0 ? (
          searchedList.map((item, index) => (
            <button key={index} className="resultItem" onClick={() => getSignInData(item)}>
              <h4>{item.name}</h4>
            </button>
          ))
        ) : (
          <h2>검색 결과가 없어요</h2>
        )}
      </div>
    </div>
  );
};

const MasterNavigator = () => {
  const navigate = useNavigate();

  const [storeList, setStoreList] = useState<HotelSelectType[]>([]);
  const [storeType, setStoreType] = useState<number>(0);

  // API 호출
  const getHotelList = async () => {
    try {
      const response = await DetectorController.getHotelList();

      if (response && response.data) {
        const formattedHotelList = response.data.data.map((item: any) => ({
          name: item.store_name,
          store_id: item.store_id,
          user_id: item.user_id,
        }));
        setStoreList(formattedHotelList);
      }
    } catch (err) {
      console.log('getHotelList err-->', err);
    }
  };

  const getSignInData = async (item: HotelSelectType) => {
    try {
      const oParams = {
        device_uuid: '',
        app_type: storeType === 0 ? APP_TYPE.KNOCK_HOTEL : APP_TYPE.KNOCK_STORE,
        version: null,
        user_id: item.user_id,
      };

      oWindow = window.open(undefined, '_blank');

      const response = await DetectorController.getSignInData(oParams);

      if (response && response.data && response.data.data) {
        // oWindow = window.open(
        //   `${
        //     storeType === 0
        //       ? process.env.REACT_APP_CEO_HOTEL_URL
        //       : process.env.REACT_APP_CEO_STORE_URL
        //   }/posLogin`,
        //   '_blank',
        // );
        if (oWindow) {
          oWindow.location.href = `${
            storeType === 0
              ? process.env.REACT_APP_CEO_HOTEL_URL
              : process.env.REACT_APP_CEO_STORE_URL
          }/posLogin`;
        }

        console.log('process.env.REACT_CEO_HOTEL_URL', process.env);

        const data = {
          type: 'admin',
          data: response.data.data,
        };
          let checkCount = 0;
          if (oWindow && !oWindow.closed) {
            const interval = setInterval(() => {
              console.log('open test', checkCount);
              if (oWindow && !oWindow.closed && checkCount < 4) {
                oWindow.postMessage(data, '*');
                checkCount++;
              }
              if (checkCount >= 4 || !oWindow || oWindow.closed) {
                clearInterval(interval);
              }
            }, 1000);
          }

        const checkIfClosed = setInterval(() => {
          if (oWindow!.closed) {
            clearInterval(checkIfClosed);
            console.log('New window was closed');
          }
        }, 1000);

        console.log('send Data', data);
      }
    } catch (err) {
      console.log('getSignInData err-->', err);
    }
  };

  useEffect(() => {
    getHotelList();
  }, []);

  return (
    <Style>
      <div className="wrap">
        <div className={`contentContainer`}>
          <button className="backButton" onClick={() => navigate(-1)}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_left.svg`} alt="ic" />
          </button>

          <h2 className="title">마스터 관리자</h2>
          <div className="selectBoxWrap">
            <button className={`${storeType === 0 && 'active'}`} onClick={() => setStoreType(0)}>
              호텔
            </button>
            <button className={`${storeType === 1 && 'active'}`} onClick={() => setStoreType(1)}>
              매장
            </button>
          </div>
          <RenderFilterStore
            storeList={storeList}
            storeType={storeType}
            getSignInData={getSignInData}
          />
        </div>
      </div>
    </Style>
  );
};

export default MasterNavigator;

const Style = styled.div`
  .backButton {
    margin-top: -2%;
    margin-left: -8%;
  }

  .title {
    margin: 24px 0;
    color: #555;
  }

  .wrap {
    flex: 1;
    display: flex;
    justify-content: center;
    min-height: 100dvh;
    background: #f7f7f7;
  }

  .contentContainer {
    width: 80%;
    margin: 0 auto;
    min-height: 100dvh;
    padding: 4% 8%;
    background: #ffffff;
    border-radius: 10px;
  }

  .selectBoxWrap {
    display: flex;
    align-items: center;
    padding-bottom: 20px;

    button {
      flex: 1;
      border: 1px solid #cecece;
      background: #f7f7f7;
      font-size: 18px;
      line-height: 24px;
      color: #555555;
      padding: 10px 0;
      text-align: center;
      cursor: pointer;
    }
    button:nth-child(1) {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    button:nth-child(2) {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
    button.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
    }
  }

  .inputArea {
    margin-top: 12px;
  }
  .inputWrap {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    input {
      flex: 1;
      border: 1px solid #aaa;
      border-radius: 5px;
      padding: 8px 10px;
      font-size: 18px;
      line-height: 24px;
      color: #555;
    }
    input:focus {
      outline-color: #4dd2ae;
    }
    input::placeholder {
      color: #cccccc;
    }

    button {
      margin-left: -8px;
      height: 42px;
      border-radius: 5px;
      padding: 0 24px;
      background: #4dd2ae;
      border: none;
    }
  }

  .resultBox {
    width: 100%;
    height: 40vh;
    border: 1px solid #aaa;
    border-radius: 5px;
    overflow-y: auto;
    margin: 12px 0 40px 0;
    .resultItem {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 20px;
      background: #fff;
      border: none;
      border-bottom: 1px solid #efefef;
      cursor: pointer;
      h4 {
        font-size: 18px;
        font-weight: 500;
        color: #555;
      }
    }
    h2 {
      padding: 20px;
      color: #555;
      font-weight: 600;
    }
  }

  @media (max-width: 800px) {
    .contentContainer {
      width: 100%;
      margin: 0 auto;
      height: 100dvh;
      padding: 4%;
      background: #ffffff;
      border-radius: 10px;
    }

    .backButton {
      margin-top: -2%;
      margin-left: -4%;
    }

    h4 {
      margin-top: 14px;
      margin-bottom: 6px;
      font-size: 14px;
      color: #555555;
    }

    input,
    textarea {
      font-size: 14px;
    }
  }
`;
